import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { getDeviationTitle } from '../../../_helpers';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { StandardThumbProps } from '../types';
import PollOverlay from './PollOverlay';
import s from './PollThumb.scss';

const PollThumb: React.FC<StandardThumbProps> = ({
  className,
  deviation,
  height,
  responsive,
  style,
  width,
  extraActions,
}) => {
  const { showOverlay, __forceHoveredForStories } = useOverlayContext(deviation);
  return (
    <HoverableWrapper
      className={classnames(s['root'], className)}
      style={{
        width,
        height,
        ...style,
      }}
      __forceHoveredForStories={__forceHoveredForStories}
    >
      <ErrorBoundary debugComponent="PollThumb">
        <DeviationDumbView
          deviation={deviation}
          width={width}
          height={height}
          responsive={responsive}
        />
        <DeviationLink
          deviation={deviation}
          className={s['link']}
          title={getDeviationTitle(deviation)}
        >
          <span />
        </DeviationLink>
        {showOverlay && (
          <Overlay
            deviation={deviation}
            width={width}
            height={height}
            className={s['overlay']}
            extraActions={extraActions}
          >
            <PollOverlay className={s['poll-overlay']} deviation={deviation} />
          </Overlay>
        )}
      </ErrorBoundary>
    </HoverableWrapper>
  );
};
PollThumb.displayName = 'PollThumb';

export default PollThumb;
